const strutRassegna = () => {
	const strutturaID = document.getElementById('vue-strutStampa').dataset.strutturaid;
	const mondoStruttura = document.getElementById('vue-strutStampa').dataset.mondo;
	const pageLink = document.getElementById('vue-strutStampa').dataset.link;
	const corporate_url = document.getElementById('vue-strutStampa').dataset.corporate;
	const endpoint_rassegna = corporate_url + '/wp-json/api/v1/stampa?struttura=' + strutturaID + '&mondo=' + mondoStruttura;

	if (document.getElementById('vue-strutStampa')) {
		var app = new Vue({
			el: '#vue-strutStampa',
			data() {
				return {
					rasStampa: [],
					loading: true,
					strutUID: '',
					headers: new Headers()
				}
			},
			mounted() {
				this.checkHeaders();
				fetch(endpoint_rassegna )
					.then(res => res.json())
					.then(data => {
						if (data.press.length > 3) {
							let removeFirstThree = data.press.splice(0, 3);
							this.rasStampa = removeFirstThree;
						} else {
							this.rasStampa = data.press;
						}
						this.strutUID = this.rasStampa[0].strutture_associate[0].structureUid;
					})

				this.loading = false;
			},
			methods: {
				checkHeaders() {
					const basic_username = document.getElementById('vue-strutStampa')?.dataset.username;
					const basic_pwd = document.getElementById('vue-strutStampa')?.dataset.pwd;

					if (basic_username && basic_pwd) {
						let credentials = btoa(basic_username + ":" + basic_pwd);
						this.headers.append('Authorization', `Basic ${credentials}`);
					}
				},
				goToPage() {
					document.location.href = pageLink + this.strutUID
				}
			},
			computed: {},
		})
	}
}

export default strutRassegna;
